




































































import ICivilization from '../ICivilization'
import Vue from 'vue'

export default Vue.extend({
  name: 'Civilization',
  computed: {
    civ (): ICivilization {
      return this.$store.getters.getCivilizationByName(this.$route.params.name)
    },
    receivedData (): boolean {
      return this.$store.state.receivedData
    }
  }
})
